import GrpcAccessorBase from '~/api/accessors/grpc-accessor-base'
import {
  GetInviteReply,
  GetInviteRequest,
  GetInviteConstantsReply,
  GetInviteConstantsRequest,
  GetSmsCertificationPhoneNumberReply,
  GetSmsCertificationPhoneNumberRequest,
  GetSmsCertificationStatusReply,
  GetSmsCertificationStatusRequest,
  GetEmailAddressReply,
  GetEmailAddressRequest
} from '~/stub/apigateway/user/user_pb'
import grpcClient from '~/grpc/grpc-client'
import { UserService } from '~/stub/apigateway/user/user_pb_service'

class UserAccessor extends GrpcAccessorBase {
  getInvite(): Promise<GetInviteReply.AsObject> {
    const metadata = this.getMetadata()
    const request = new GetInviteRequest()
    return grpcClient({
      method: UserService.GetInvite,
      request,
      metadata
    })
  }

  getInviteConstants(): Promise<GetInviteConstantsReply.AsObject> {
    const metadata = this.getMetadata()
    const request = new GetInviteConstantsRequest()
    return grpcClient({
      method: UserService.GetInviteConstants,
      request,
      metadata
    })
  }

  getSmsCertificationPhoneNumber(): Promise<GetSmsCertificationPhoneNumberReply.AsObject> {
    const metadata = this.getMetadata()
    const request = new GetSmsCertificationPhoneNumberRequest()
    return grpcClient({
      method: UserService.GetSmsCertificationPhoneNumber,
      request,
      metadata
    })
  }

  getSmsCertificationStatus(): Promise<GetSmsCertificationStatusReply.AsObject> {
    const metadata = this.getMetadata()
    const request = new GetSmsCertificationStatusRequest()
    return grpcClient({
      method: UserService.GetSmsCertificationStatus,
      request,
      metadata
    })
  }

  getEmailAddress(): Promise<GetEmailAddressReply.AsObject> {
    const metadata = this.getMetadata()
    const request = new GetEmailAddressRequest()
    return grpcClient({
      method: UserService.GetEmailAddress,
      request,
      metadata
    })
  }
}

export default UserAccessor
